// extracted by mini-css-extract-plugin
export var equalColumn = "_jl-0";